import { login, regist,logout, getInfo, renewExpire } from '@/api/user'
import { getRole, getUserId, setSecretKey, setUserId, setUserRole, setUserAccount, setExpire, setRole, setCrypt, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { encrypt, decrypt } from '@/utils/encrypt'

const state = {
  token: getRole(),
  userid: '',
  name: '',
  avatar: '',
  introduction: '',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_SECRETKEY: (state, secret_key) => {
    state.secret_key = secret_key
  },
  SET_EXPIRE: (state, expire) => {
    state.expire = expire
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_USERID: (state, user_id) => {
    state.userid = user_id
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password, code } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: account.trim(), password: password, code: code  }).then(response => {
        const { data } = response
		const cryptToken = encrypt({ token: data.token, secret_key: data.secret_key, role: data.role, expire: data.expire, user_id: data.user_id});//加密
        commit('SET_TOKEN', data.token)
		setCrypt(encodeURIComponent(cryptToken))
        setToken(data.token)
        setSecretKey(data.secret_key)
        setUserId(data.user_id)
		setUserRole(data.role)
        setExpire(data.expire)
        setUserAccount(account.trim())
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  regist({ commit }, userInfo) {
    const { account, password, phone } = userInfo
    return new Promise((resolve, reject) => {
      regist({ account: account.trim(), password: password, mobile: phone  }).then(response => {
        const { data } = response
		const cryptToken = encrypt({ token: data.token, secret_key: data.secret_key, role: data.role, expire: data.expire, user_id: data.user_id});//加密
        commit('SET_TOKEN', data.token)
		setCrypt(encodeURIComponent(cryptToken))
        setToken(data.token)
        setSecretKey(data.secret_key)
        setUserId(data.user_id)
		setUserRole(data.role)
        setExpire(data.expire)
        setUserAccount(account.trim())
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({user_id:getUserId()}).then(response => {
        const  data  = response.data
        if (!data) {
          reject('身份验证失败, 请重新登录。')
        }
        const { role, nickname, head_image, manage_power, id } = data
        //console.log(data)
        // roles must be a non-empty array
        if (!role || role.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        setRole(role)
        commit('SET_ROLES', [role])
        commit('SET_USERID', id)
        commit('SET_NAME', nickname)
        commit('SET_AVATAR', head_image)
        resolve({roles:[role], name:nickname, avatar:head_image, manage_power:manage_power})
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout({}).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
		
        removeToken()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        //dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  renewExpire(){
    return new Promise((resolve, reject) => {
      renewExpire({}).then(response => {
        setExpire(response.data.expire)
         resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setRole(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
